import { STORE, del, getAllByIndex, put } from './db';

/**
 * ROM ごとのチートコード。
 *
 * コードは複数行になることがある（1 つの効果を複数のアドレス書き換えで実現する）。
 * libretro のコアには生の文字列をそのまま渡すので、ここでは正規化した文字列を保つ。
 */
export interface CheatRecord {
  /** `${romId}:${連番}` */
  id: string;
  romId: string;
  /** 表示名（「無限ライフ」など） */
  label: string;
  /** 改行区切りのコード。正規化済み。 */
  code: string;
  enabled: boolean;
  createdAt: number;
}

export async function listCheats(romId: string): Promise<CheatRecord[]> {
  const rows = await getAllByIndex<CheatRecord>(STORE.cheats, 'romId', romId);
  return rows.sort((a, b) => a.createdAt - b.createdAt);
}

export async function addCheat(romId: string, label: string, code: string): Promise<CheatRecord> {
  const record: CheatRecord = {
    id: `${romId}:${crypto.randomUUID()}`,
    romId,
    label: label.trim() || '名称未設定',
    code,
    enabled: true,
    createdAt: Date.now(),
  };
  await put(STORE.cheats, record);
  return record;
}

export async function updateCheat(record: CheatRecord): Promise<void> {
  await put(STORE.cheats, record);
}

export async function deleteCheat(id: string): Promise<void> {
  await del(STORE.cheats, id);
}

/** 有効なチートのコードだけを、コアへ渡す順に並べて返す。 */
export async function activeCheatCodes(romId: string): Promise<string[]> {
  const cheats = await listCheats(romId);
  return cheats
    .filter((c) => c.enabled)
    .flatMap((c) => c.code.split('\n').map((l) => l.trim()).filter(Boolean));
}
